import { useTranslation } from 'react-i18next'

const StepperNav = ({step, setStep, prev, next, isValid, testConnection=false,isNextSubmit=false, onClose}) => {
    const { t } = useTranslation("settings");
    const handleNext = () => {
        if(testConnection){
            //test connection
            setStep(step + 1);
        }
        else{
            setStep(step + 1);
        }
    }
    const handlePrev = () => {
        if(prev==`< ${t('device_management.server_setup.select_server')}`){
            setStep(1)
        }else{
            if(step>1){setStep(step - 1);}
            else{onClose(false)}
        }
        

    }

    return ( 
    <div className="flex items-center justify-end w-full pt-4 mt-4 border-t gap-x-2">
        
        <button 
        type="button" 
        onClick={handlePrev}
        className="py-2.5 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm " >
        {prev}
        </button >

        <button 
        type={isNextSubmit?"submit":"button"}
        onClick={isNextSubmit ? null : handleNext}
        disabled={!isValid}
        className="py-2.5 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-vekin text-white shadow-sm align-middle hover:bg-vekin/90 hover:shadow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm disabled:grayscale ">
            {next}
        </button>



    </div>
     );
}
 
export default StepperNav;